import { render, staticRenderFns } from "./point.vue?vue&type=template&id=8d7e82da&scoped=true&"
import script from "./point.vue?vue&type=script&lang=ts&"
export * from "./point.vue?vue&type=script&lang=ts&"
import style0 from "./point.vue?vue&type=style&index=0&id=8d7e82da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7e82da",
  null
  
)

export default component.exports